var React = require('react');

function MailInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16.665 0H1.79004C1.20354 0 0.727539 0.451886 0.727539 1.00867V1.58261L9.22754 5L17.7275 1.5816V1.00867C17.7275 0.451886 17.2515 0 16.665 0Z","fill":"white","key":0}),React.createElement("path",{"d":"M9.43473 6.56441C9.36885 6.59353 9.29766 6.60755 9.22754 6.60755C9.15741 6.60755 9.08623 6.59353 9.02035 6.56441L0.727539 3V10.9215C0.727539 11.5168 1.20354 12 1.79004 12H16.665C17.2515 12 17.7275 11.5168 17.7275 10.9215V3L9.43473 6.56441Z","fill":"white","key":1})]);
}

MailInline.defaultProps = {"width":"18","height":"12","viewBox":"0 0 18 12","fill":"none"};

module.exports = MailInline;

MailInline.default = MailInline;
